const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99 6.5C9.71386 6.5 9.49 6.72386 9.49 7C9.49 7.27614 9.71386 7.5 9.99 7.5V6.5ZM10 7.5C10.2761 7.5 10.5 7.27614 10.5 7C10.5 6.72386 10.2761 6.5 10 6.5V7.5ZM10.5 9V8.5H9.5V9H10.5ZM9.5 13V13.5H10.5V13H9.5ZM16.5 10C16.5 13.5899 13.5899 16.5 10 16.5V17.5C14.1421 17.5 17.5 14.1421 17.5 10H16.5ZM10 16.5C6.41015 16.5 3.5 13.5899 3.5 10H2.5C2.5 14.1421 5.85786 17.5 10 17.5V16.5ZM3.5 10C3.5 6.41015 6.41015 3.5 10 3.5V2.5C5.85786 2.5 2.5 5.85786 2.5 10H3.5ZM10 3.5C13.5899 3.5 16.5 6.41015 16.5 10H17.5C17.5 5.85786 14.1421 2.5 10 2.5V3.5ZM9.5 9V13H10.5V9H9.5ZM9.99 7.5H10V6.5H9.99V7.5Z"
      fill="currentColor"
    />
  </svg>
);

export { InfoIcon };
